import { Link } from 'roo-ui/components';

const TelLink = ({ number, ...rest }) => (
  <Link href={`tel: ${number}`} {...rest}>
    {number}
  </Link>
);

export default TelLink;
